/**
 * Free OSM raster basemap for MapLibre (no API key).
 * Optional: set REACT_APP_MAP_TILE_URL to a tile URL template with {z}/{x}/{y},
 * e.g. a self-hosted server to avoid public tile limits at scale.
 */
export function getOsmRasterStyle() {
  const envTileUrl =
    typeof process !== 'undefined' && process && process.env
      ? process.env.REACT_APP_MAP_TILE_URL
      : '';
  const tiles = (
    envTileUrl || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
  ).split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  return {
    version: 8,
    // Needed for any symbol/text layers (e.g., cluster counts).
    // Public glyphs endpoint (free, no key).
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf',
    sources: {
      osm: {
        type: 'raster',
        tiles,
        tileSize: 256,
        attribution:
          '© <a href="https://www.openstreetmap.org/copyright" rel="noreferrer">OpenStreetMap</a>',
      },
    },
    layers: [
      {
        id: 'osm',
        type: 'raster',
        source: 'osm',
        minzoom: 0,
        maxzoom: 19,
      },
    ],
  };
}
